import Default from "@/Layouts/Default";
import Hero from "@/Sections/Hero";
import { Head } from "@inertiajs/inertia-react";
import Counter from "@/Sections/Counter";
import BeforeAfter from "@/Sections/BeforeAfter";
import About from "@/Sections/About";
import Contact from "@/Sections/Contact";
import Features from "@/Sections/Features";
import { Link, animateScroll as scroll } from "react-scroll";
import Spotify from "@/Components/Spotify";
import Listen from "@/Sections/Listen";
import Guarantees from "@/Sections/Guarantees";
import AboutFeatures from "@/Sections/AboutFeatures";

export default function AboutPage() {
    return (
        <Default>
            <Head>
                <title>Waarom WE ARE</title>
                <link rel="canonical" href={route("about")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Jouw transformatie binnen 12 weken? Bij WE ARE personal training Uden en Schijndel regelen we het! Geen resultaat = geld terug!"
                />
                <meta
                    property="og:description"
                    content="Jouw transformatie binnen 12 weken? Bij WE ARE personal training Uden en Schijndel regelen we het! Geen resultaat = geld terug!"
                />
                <meta property="og:url" content={route("about")} />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Waarom WE ARE - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/personal-training-uden-schijndel.png"
                />
            </Head>

            <div className="bg-black">
                <Hero homepage={false}></Hero>

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                    <div className="max-w-4xl mx-auto text-center">
                        <h2 className="block text-white mx-auto font-custom italic font-bold uppercase max-w-4xl xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl mt-8">
                            Waarom de WE ARE methode
                        </h2>
                        <p className="mt-4 text-lg text-gray-100">
                            In een wereld waar de ene na de andere PT studio
                            ontstaat , is het gemakkelijk om het spoor bijster
                            te raken. Beloftes vliegen je om de oren terwijl de
                            kwaliteit steeds minder wordt. We snappen daarom dat
                            je sceptisch bent. Weer een nieuwe methode? Weer een
                            belofte? Waarom zou dit wel helpen? Maar blijf even
                            hangen, want de WE ARE methode is niet zoals de
                            tientallen PT studio’s op de hoek van de straat. Het
                            is een bewezen formule, anders dan al het andere dat
                            je tot nu toe hebt geprobeerd.
                        </p>
                    </div>

                    <AboutFeatures />

                    <Guarantees />

                    <div className="max-w-4xl mx-auto text-center">
                        <h2 className="block text-white mx-auto font-custom italic font-bold uppercase max-w-4xl xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl mt-8">
                            Dus, waar wacht je nog op?
                        </h2>
                        <p className="mt-4 text-lg text-gray-100">
                            De WE ARE methode is meer dan een fitnessprogramma.
                            Het is een levensveranderende ervaring. Ben je klaar
                            om de beste versie van jezelf te worden? Wij staan
                            klaar om je te begeleiden, elke stap van de weg.
                            Laten we samen jouw transformatie realiseren!
                        </p>

                        <Link
                            to="contact"
                            smooth={true}
                            offset={0}
                            duration={800}
                            className="mt-12 uppercase ml-4 inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-white bg-we-are-purple focus:outline-none focus:ring-2 focus:ring-offset-2"
                        >
                            Start hier jouw transformatie
                        </Link>
                    </div>
                </div>

                {/* <About /> */}

                {/* <Spotify /> */}

                <Contact />
            </div>
        </Default>
    );
}
